import { render, staticRenderFns } from "./AppCustomerStartNewOrderSlider.vue?vue&type=template&id=9a58e29a&scoped=true&"
import script from "./AppCustomerStartNewOrderSlider.vue?vue&type=script&lang=js&"
export * from "./AppCustomerStartNewOrderSlider.vue?vue&type=script&lang=js&"
import style0 from "./AppCustomerStartNewOrderSlider.vue?vue&type=style&index=0&id=9a58e29a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a58e29a",
  null
  
)

export default component.exports